// extracted by mini-css-extract-plugin
module.exports = {"FAQElement":"FAQElement_FAQElement__2qSBS","FAQElement__Summary":"FAQElement_FAQElement__Summary__5uTNh","FAQElement__Details":"FAQElement_FAQElement__Details__1CF8N"};